module.exports = __webpack_public_path__ + "img/pd-img23.c48b362d.png";